import React from "react";
import { useGlobal } from "reactn";
import classnames from "classnames";
import { NavLink } from "react-router-dom";

const MobileMenu = (props) => {
  const [menuOpen, setMenuOpen] = useGlobal("mobileMenuOpen");
  const [worldsPromo, setWorldsPromo] = useGlobal("worldsPromo");
  const closeMenu = () => {
    setMenuOpen(false);
  };
  const mobileMenuClassNames = classnames("mobile-menu-container", menuOpen && "mobile-menu-container_open");
  return (
    <div className={mobileMenuClassNames}>
      {menuOpen && <div className="mobile-menu_backdrop" onClick={closeMenu}></div>}
      <div className="mobile-menu">
        <NavLink to={"/champions"} onClick={closeMenu}>
          <span>Champions</span>
        </NavLink>
        <NavLink to={"/pros"} onClick={closeMenu}>
          <span>Pros</span>
        </NavLink>
        <NavLink to={"/top-picks"} onClick={closeMenu}>
          <span>Top 20 Picks</span>
        </NavLink>
      </div>
    </div>
  );
};

export default MobileMenu;
